import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { dimensionsGridDataSelector } from "@/store/dimensions/selectors/dimensions-data/dimensionsGridDataSelector";
import { CategoryWithDimensionId } from "@/store/dimensions/utils/types/common";

export type CategoriesByDimensionIdMap = Record<
  string,
  CategoryWithDimensionId[]
>;

export const categoriesByDimensionIdMapSelector = createDraftSafeSelector(
  [dimensionsGridDataSelector],
  (data) => {
    if (!data) {
      return;
    }

    return data.reduce((acc, curr) => {
      acc[curr.id] = curr.children;

      return acc;
    }, {} as CategoriesByDimensionIdMap);
  },
);
